import { takeLatest, put } from 'redux-saga/effects';

import {
    CANCEL_ANIMAL_CADASTRO_RAPIDO,
    CANCEL_ANIMAL_CADASTRO_RAPIDO_SUCCESS
} from '../actionTypes';

function* sagaCancelAnimalCadastroRapido() {
  yield put({ type: CANCEL_ANIMAL_CADASTRO_RAPIDO_SUCCESS})
}

export default function* watchCancelAnimalCadastroRapido() {
  yield takeLatest(CANCEL_ANIMAL_CADASTRO_RAPIDO, sagaCancelAnimalCadastroRapido)
}